<template>
  <div :class="['detail', { inApp: $root.$data.isApp }]">
    <common-title titleName="退课详情" :bcColor="'#f9f9f9'" :zIndex="1000"></common-title>
    <div v-for="(item, index) in orderDetail" :key="index">
      <div class="status">
        <p>{{ filterOrderType(item.refundStatus) }}</p>
        <p>退课</p>
      </div>
      <div class="detail_info">
        <div class="old_info">
          <ul>
            <li v-for="(ite, ind) in item.productInfoList" :key="ind">
              <p>{{ ite.productName }}</p>
              <span>￥{{ ite.productAmount }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="price_info">
        <ul>
          <li>
            <div>应退差价</div>
            <p>￥{{ item.refundAmount }}</p>
          </li>
          <li>
            <div>退至</div>
            <p>{{ filterrefundType(item.refundAmountType) }}</p>
          </li>
        </ul>
      </div>
      <div class="order_info">
        <ul>
          <li>
            <p>售后编号</p>
            <div>{{ item.refundNo }} <span @click="orderNoCopy"></span></div>
          </li>
          <li>
            <p>售后时间</p>
            <div>{{ item.createTime }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { copyTool } from '@/utils/tools';
import { reqExitDetail } from '@/api/personal/returnClass';
import { orderType, refundAmountType } from '../returnClassTools';

export default {
  data() {
    return {
      orderNo: this.$route.query.orderNo,
      orderDetail: [],
    };
  },

  components: { CommonTitle },

  computed: {},

  mounted() { },

  created() {
    this.getOrderDetail();
  },
  methods: {
    async getOrderDetail() {
      try {
        const res = await reqExitDetail(this.$route.query.orderNo);
        if (res.code === 0) {
          this.orderDetail.push(res.data);
        } else {
          this.$toast(res.msg);
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
    orderNoCopy() {
      copyTool(this.orderNo)
        .then(() => {
          this.$toast('复制成功');
        })
        .catch(() => {
          this.$toast('复制失败');
        });
    },
    // 判断订单状态
    filterOrderType(status) {
      return orderType(status);
    },
    // 判断退款方式
    filterrefundType(status) {
      return refundAmountType(status);
    },
  },
};
</script>
<style lang="scss" scoped>
.detail {
  width: 86%;
  margin: 0 auto 40px;
  padding-top: 100px;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.price_info {
  margin: 20px 0;
  padding: 30px;
  background-color: #fff;
  border-radius: 14px;
  li {
    display: flex;
    justify-content: space-between;
    height: 50px;
    line-height: 52px;
    div {
      color: #333;
      font-weight: bold;
      font-size: 25px;
    }
    p {
      color: #ff6c02;
      font-weight: bold;
      font-size: 25px;
    }
  }
}
.old_info span {
  color: #333;
  font-size: 25px;
}
.detail_info {
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 14px;
  li {
    display: flex;
    justify-content: space-between;
    height: 60px;
    line-height: 62px;
    p {
      width: 476px;
      overflow: hidden;
      color: #333;
      font-weight: 400;
      font-size: 29px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.order_info {
  padding: 30px;
  background-color: #fff;
  border-radius: 14px;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    p {
      color: #333;
      font-weight: bold;
      font-size: 25px;
    }
    div {
      color: #787878;
      font-size: 25px;
      span {
        display: inline-block;
        width: 48px;
        height: 48px;
        vertical-align: middle;
        background: url('../../../../assets/img/personalImg/copy.png') no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
  li:last-child {
    margin-bottom: 0;
  }
}

.status {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 40px 0;
  p:first-child {
    color: #ff6c02;
    font-weight: 500;
    font-size: 43px;
  }
  p:last-child {
    color: #ff6c02;
    font-weight: 500;
    font-size: 25px;
  }
}
</style>
